import moment from "moment";
import {
    DATE_OPTIONS,
    getBeginLocalStr,
    getBeginStr,
    getDateFromNow,
    getEndLocalStr,
    getEndStr
} from "../../../core/utils/date-utils";

/**
 * Faturalandırma grid'inin açılış filtresi ve tarih biçimi — sol panel (ReportBillingFilter) ve hızlı filtre
 * çubuğu (ReportBillingQuickFilterBar) ortak kullanır; ikisi aynı filtreyi uyguladığı için biçim tek yerde.
 */

// Sunucudaki ReportBillingDateType ile birebir.
export const BILLING_DATE_TYPE = {
    CONFIRM: 0,
    REPORT: 1,
    STUDY: 2,
}

// Çekim tarihi sunucuda timezone'suz duvar saati (Unspecified), onay/rapor tarihi UTC — gönderim biçimi türe bağlı.
export const toFilterDates = (dateType, begin, end) => {
    const isLocal = dateType === BILLING_DATE_TYPE.STUDY;

    return {
        dateBegin: isLocal ? getBeginLocalStr(begin) : getBeginStr(begin),
        dateEnd: isLocal ? getEndLocalStr(end) : getEndStr(end),
    }
}

// Filtredeki tarih string'i → ekranda gösterilecek yerel gün. Çekim tarihi "Z" ile yazılsa da duvar saatidir:
// moment(str) onu yerel saate kaydırır ve UTC+ saat diliminde bitişi ertesi güne taşırdı.
export const fromFilterDate = (dateType, value) => {
    if (!value)
        return null;
    if (moment.isMoment(value))
        return value;

    return dateType === BILLING_DATE_TYPE.STUDY
        ? moment(moment.utc(value).format('YYYY-MM-DDTHH:mm:ss.SSS'))
        : moment(value);
}

export const buildDefaultReportBillingFilter = () => {
    const date = getDateFromNow(DATE_OPTIONS.LAST_15_DAYS);

    return {
        dateType: BILLING_DATE_TYPE.CONFIRM,
        ...toFilterDates(BILLING_DATE_TYPE.CONFIRM, date.start, date.end),
        billingStatusList: [],
        hospitalIdList: [],
    }
}
